import React from 'react';

export interface ToastMessage {
  text: string;
  type: 'success' | 'error';
}

export default function Toast({ message }: { message: ToastMessage | null }) {
  if (!message) return null;
  const isError = message.type === 'error';
  return (
    <div
      className="fixed top-5 right-5 z-[200] flex items-center gap-2.5 px-4 py-3 rounded-xl shadow-lg border animate-[fadeIn_0.2s_ease-out]"
      style={{
        background: isError ? '#fef2f2' : '#f0fdf4',
        borderColor: isError ? '#fecaca' : '#bbf7d0',
      }}
    >
      <i
        className={`ti ${isError ? 'ti-alert-circle' : 'ti-circle-check'}`}
        style={{ fontSize: 17, color: isError ? '#dc2626' : '#16a34a' }}
      />
      <p className="text-[13px] font-bold" style={{ color: isError ? '#991b1b' : '#166534' }}>
        {message.text}
      </p>
    </div>
  );
}
